import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DirectionalDerivative = () => (
  <QPhototModuleSubtopic
    title="Directional derivative"
    videos={[
      "https://www.youtube.com/embed/g4H_mEwOFoM",
      "https://www.youtube.com/embed/vNJ3gJEcWiA"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_62.jpeg"
        },
        {
            image:"/cal_63.jpeg"
        },
        {
            image:"/cal_64.jpeg"
        },
        {
            image:"/cal_65.jpeg"
        },
    ]}
    exampleVideos={[]}
  />
);

export default DirectionalDerivative;
